class MobileMenu {
    constructor() {
        this.toggleBtns = document.querySelectorAll('.mobile-menu-toggle')
        this.backBtns = document.querySelectorAll('.mobile-menu-back')
        this.container = document.querySelector(
            '.menu-site-header-mobile-container'
        )
        this.firstLevelMenuItems = document.querySelectorAll(
            '#menu-site-header-mobile > li.menu-item-has-children > a'
        )
        this.secondLevelMenuItems = document.querySelectorAll(
            '#menu-site-header-mobile > li.menu-item-has-children > ul.sub-menu > li.menu-item-has-children > a'
        )
        this.firstLevelSubmenus = document.querySelectorAll(
            '#menu-site-header-mobile  > li.menu-item-has-children > .sub-menu'
        )
        this.secondLevelSubmenus = document.querySelectorAll(
            '#menu-site-header-mobile  > li.menu-item-has-children > .sub-menu > .menu-item-has-children > .sub-menu'
        )

        this.level = 0

        this.bindEventListeners()
        this.init()
    }

    bindEventListeners() {
        this.toggleBtns.forEach((toggleBtn) => {
            toggleBtn.addEventListener('click', (e) => this.handleToggle(e))
        })
        this.backBtns.forEach((backBtn) => {
            backBtn.addEventListener('click', (e) => this.handleBack(e))
        })

        this.firstLevelMenuItems.forEach((firstLevelMenuItem) => {
            this.addIndicator(firstLevelMenuItem)
            firstLevelMenuItem.addEventListener('click', (e) =>
                this.handleFirstLevelClick(e)
            )
        })

        this.secondLevelMenuItems.forEach((secondLevelMenuItem) => {
            this.addIndicator(secondLevelMenuItem)
            secondLevelMenuItem.addEventListener('click', (e) =>
                this.handleSecondLevelClick(e)
            )
        })
    }

    init() {}

    handleBack(e) {
        e.preventDefault()

        if (this.level === 2) {
            this.secondLevelSubmenus.forEach((submenu) =>
                submenu.classList.remove('active')
            )
        } else if (this.level === 1) {
            this.firstLevelSubmenus.forEach((submenu) =>
                submenu.classList.remove('active')
            )
        }

        this.setLevel(this.level - 1)
    }

    handleToggle(e) {
        e.preventDefault()

        this.resetLevel()
        document.body.classList.toggle('mobile-menu-active')
    }

    setLevel(level = 0) {
        this.level = level
        document.body.setAttribute('data-mobile-menu-level', level)
    }

    resetLevel() {
        this.setLevel(0)

        this.firstLevelSubmenus.forEach((submenu) =>
            submenu.classList.remove('active')
        )
        this.secondLevelSubmenus.forEach((submenu) =>
            submenu.classList.remove('active')
        )
    }

    handleFirstLevelClick(e) {
        e.preventDefault()

        const clicked = e.currentTarget
        const submenu = clicked.nextElementSibling

        if (submenu && submenu.classList.contains('sub-menu')) {
            submenu.classList.add('active')
            this.setLevel(1)
        }
    }

    handleSecondLevelClick(e) {
        e.preventDefault()

        const clicked = e.currentTarget
        const submenu = clicked.nextElementSibling

        if (submenu && submenu.classList.contains('sub-menu')) {
            submenu.classList.add('active')
            this.setLevel(2)
        }
    }

    addIndicator(target) {
        const svgIcon = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" height="24" width="24">
            <path d="M23.025 12H0.975" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path>
            <path d="M19.35 15.675L23.025 12L19.35 8.325" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path>
        </svg>`

        const span = document.createElement('span')
        span.innerHTML = svgIcon
        span.classList.add('mobile-menu-item-children-indicator')

        target.appendChild(span)
    }
}

export default MobileMenu
